module.exports = __webpack_public_path__ + "./favicon/apple-icon-114x114.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=./favicon/[name].[ext]!./src/favicon/apple-icon-114x114.png
// module id = 8189
// module chunks = 0